import React, { Component } from "react";

import SimpleSelect from "../../elements/CustomSelect/SimpleSelect";
import { withMainContext } from "../../hoc/withMainContext";

class CurrencySelect extends Component {
  render() {
    // console.log('CurrencySelect', this.props.disabled)
    // console.log("props", this.props);
    const currencies = this.props.currencies;
    let options = [];
    let value = this.props.value;
    if (currencies) {
      options = currencies.map(currency => {
        return { label: currency.code, value: currency.id };
      });
    }

    console.log("CurrencySelect", value);
    return (
      <SimpleSelect
        name="currency"
        value={value}
        onSelected={this.props.onSelected}
        options={options}
        clearable={false}
        disabled={this.props.disabled}
      />
    );
  }
}

export default withMainContext(CurrencySelect);
